import React from 'react';
import { db } from './Firebase';

const UpdateLogo = () => {
    
    function updateLogo(e) {
        e.preventDefault();
        
        const logo = document.getElementById('logoID');
        const form = new FormData();
        form.append('image', logo.files[0]);

        // uploading to imgbb
        fetch('https://api.imgbb.com/1/upload?key=5159c527ffc84ce94be36652b3fa0c9f', 
        { method: 'POST', body: form })
        .then(res => res.json())
        .then(image => {

            // updating document
            db.collection('logo').doc('RgQBLYaNTaUUKRrEKT7a')
            .update({url : image.data.url})
            .then(() => {
                logo.value = '';
                document.getElementById('successLogo').innerHTML = 'Logo Updated!';
            });
        })
    }

    return (
        <div className="col-md-6 mb-5 mb-md-0">
            <article className="shadow px-3 py-4 p-md-5 h-100">
                <h4 className="title mb-4"><b>Update Logo</b></h4>
                <form className="px-2" onSubmit={updateLogo}>
                    <input type="file" id="logoID" className="my-3" name="logo" required />
                    <input type="submit" value="Update Logo" className="text-white btn btn-one px-5" />
                </form>
                <p id="successLogo" className="text-center my-3 text-success"></p>
            </article>
        </div>
    );
};

export default UpdateLogo;